import TitleBar from '../../components/TitleBar';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components';
import { useUserContext } from '../../context/PermissionsContext';
import TitleUpdater from '../../components/common/TitleUpdater';

function ExposureQuantification() {
  const navigate = useNavigate();

  const { isLocation } = useUserContext();

  return (
    <div className="min-h-screen">
      <TitleUpdater title="Exposures" />
      <TitleBar
        title="Exposure Quantification"
        subtitle="Overview"
        brief="This section is critical to quantify the organization's exposures. MEO steps through
                      interdependency mapping, mitigation quantification, and exposure quantification to achieve this.
                      The more detail added to the section in this module, the more accurate the picture of risk
                      becomes."
      />
      <div className="max-w-176 mx-auto pb-10">
        <div className="flex flex-col gap-2.5">
          <h3 className="text-tertiary-500 text-sm font-bold tracking-widest">
            DEPENDENCY MAPPING
          </h3>
          {!isLocation && (
            <Button
              type="primary"
              className="w-full py-4 text-base"
              onClick={() => navigate('/dependency-mapping/division-selection')}
            >
              Location Dependencies
            </Button>
          )}
          <Button
            type="primary"
            className="w-full py-4 text-base"
            onClick={() => navigate('/location-selection')}
          >
            Process Area & Process Dependencies
          </Button>
          <Button
            type="primary"
            className="w-full py-4 text-base"
            onClick={() => navigate('/suppliers-dependencies')}
          >
            Supplier Dependencies
          </Button>
          <h3 className="text-tertiary-500 text-sm font-bold tracking-widest">
            MITIGATION
          </h3>
          {!isLocation && (
            <Button
              type="primary"
              className="w-full py-4 text-base"
              onClick={() => navigate('/finished-goods-inventory')}
            >
              Finished Goods Inventory
            </Button>
          )}
          <Button
            type="primary"
            className="w-full py-4 text-base"
            onClick={() => navigate('/internal-external-mitigation')}
          >
            Location Mitigation
          </Button>
          <Button
            type="primary"
            className="w-full py-4 text-base"
            onClick={() => navigate('/pa-location-selection')}
          >
            Process Area & Process Mitigation
          </Button>
          <h3 className="text-tertiary-500 text-sm font-bold tracking-widest">
            REPORTS
          </h3>
          <Button
            type="primary"
            className="w-full py-4 text-base"
            onClick={() => navigate('/corporate-view')}
          >
            Dependency Matrix
          </Button>
          <Button
            type="primary"
            className="w-full py-4 text-base"
            onClick={() => navigate('/exposure-summary')}
          >
            Exposure Summary
          </Button>
          <Button
            type="primary"
            className="w-full py-4 text-base"
            onClick={() => navigate('/exposure-summary/suppliers')}
          >
            Supplier Exposure Summary
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ExposureQuantification;
